/**
 * Formats phone number for GTM tracking events
 * Ensures consistent format: +48123456789 (with + prefix and no spaces)
 */
export const formatGtmPhoneNumber = (phone: string): string => {
    return phone.startsWith("+") ? phone.replace(/ /g, "") : `+${phone.replace(/ /g, "")}`;
};
/**
 * Formats phone number for GTM tracking events
 * Ensures consistent format: +48123456789 (with + prefix and no spaces)
 */
export const formatGtmPhoneNumber = (phone: string): string => {
    return phone.startsWith("+") ? phone.replace(/ /g, "") : `+${phone.replace(/ /g, "")}`;
};
